import { Renderer2, Component, OnInit, Input, Inject, OnChanges } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { GoogleChartBaselineTaskInfo } from '../../model/GoogleOrgChartInfo';
import { DOCUMENT } from '@angular/common';



@Component({
  selector: 'app-google-columns-chart',
  templateUrl: './google-columns-chart.component.html',
  styleUrls: ['./google-columns-chart.component.css']
})
export class GoogleColumnsChartComponent implements OnChanges {
  @Input() Title: string;
  @Input() Subtitle: string;
  @Input() Labels: string;
  @Input() Colors: string;
  @Input() DataSets: string;

  IsShowTitle: boolean;
  IsFirstTime: boolean = true;
  constructor(@Inject(DOCUMENT) private _document: Document, private renderer2: Renderer2, private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string)
  {
  }

  async ngOnChanges() {
    
    this.IsShowTitle = !!this.Title;
    await this.OnloadBaseline(this.IsFirstTime);
    var that = this;
    if (!!this.DataSets) {
      this.IsFirstTime = false;
      await setTimeout(function () {
        that.initialGoogleColumnsChartData();
      }, 1000)
    }
    
  }

  

  //Chart zone
  initialGoogleColumnsChartData() {
    var jsCode = `
 
  google.charts.load('current', {packages: ['corechart', 'bar']});
  google.charts.setOnLoadCallback(drawColumnChart);

function drawColumnChart() {
    var jsonStr = `
    jsCode += this.DataSets;
    jsCode += `
    var data = google.visualization.arrayToDataTable(jsonStr);

     var options = {
        legend: {position: 'none'},
        bars: 'vertical',
        vAxis: {format: 'decimal'},
        height: 300,
        colors:`
    jsCode += this.Colors;
    jsCode +=`
      };

      var chart = new google.charts.Bar(document.getElementById('columns_chart_div'));
      chart.draw(data, options);
    }`;

    
    this.RenderChart(jsCode);

  }
  RenderChart(data: string) {
    //ประกาศ tag script เข้าไปใหม่
    let script = this.renderer2.createElement('script');
    script.setAttribute("id", "scriptcolumns_chart");
    script.type = 'text/javascript';
    script.text = data;

    this.renderer2.appendChild(this._document.body, script);
  }
  OnloadBaseline(flagfirsttime: boolean = true) {
    $('#scriptcolumnchart').remove();
    $('#cart_lib').remove();
    if (flagfirsttime == true) {
      var css = `<style>.google-visualization-tooltip {
          width: unset !IMPORTANT;
          height: unset !IMPORTANT;
      }</style>`;
      $('body').append(css);
      
    }
  }
}
